// Import model
import { CreateCompanyRequest } from '../models/CreateCompanyRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CreatePhoneNumberRequest } from '../models/CreatePhoneNumberRequest';

// Import dependency serializers (for complex types)
import { CreatePhoneNumberRequestSerializer } from './CreatePhoneNumberRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateCompanyRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateCompanyRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateCompanyRequest instance
   */
  static deserialize(json: string): CreateCompanyRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateCompanyRequest instance
   */
  static fromObject(obj: any): CreateCompanyRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateCompanyRequest');
    }


    const instance: CreateCompanyRequest = {
      name: obj['name'] as string,
      parentContactId: obj['parentContactId'] as string | undefined,
      role: obj['role'] as string | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      address: obj['address'] as string | undefined,
      city: obj['city'] as string | undefined,
      state: obj['state'] as string | undefined,
      postalCode: obj['postalCode'] as string | undefined,
      country: obj['country'] as string | undefined,
      email: obj['email'] as string | undefined,
      location: obj['location'] as any | undefined,
      phoneNumbers: obj['phoneNumbers'] ? (obj['phoneNumbers'] as any[]).map((item: any) =>
        CreatePhoneNumberRequestSerializer.fromObject(item)
      ) : [] as any,
      entityId: obj['entityId'] as string | undefined,
      notes: obj['notes'] as string | undefined,
      address2: obj['address2'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateCompanyRequest instances
   */
  static deserializeArray(json: string): CreateCompanyRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateCompanyRequest instance to a JSON string
   */
  static serialize(instance: CreateCompanyRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateCompanyRequest instance to a plain object
   */
  static toObject(instance: CreateCompanyRequest): any {
    return {
      'name': instance.name,
      'parentContactId': instance.parentContactId,
      'role': instance.role,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'address': instance.address,
      'city': instance.city,
      'state': instance.state,
      'postalCode': instance.postalCode,
      'country': instance.country,
      'email': instance.email,
      'location': instance.location,
      'phoneNumbers': instance.phoneNumbers?.map((item: any) =>
        CreatePhoneNumberRequestSerializer.toObject(item)
      ),
      'entityId': instance.entityId,
      'notes': instance.notes,
      'address2': instance.address2,
    };
  }

  /**
   * Serializes an array of CreateCompanyRequest instances to a JSON string
   */
  static serializeArray(instances: CreateCompanyRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
